import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/healthcare/index";

export const Route = createFileRoute("/admin/_modules/_healthcare/healthcare")({
  component: Page,
});
